import "@/App.css";
import { BrowserRouter, Navigate, Routes, Route } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import { Toaster } from "@/components/ui/sonner";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { SettingsProvider, AuthSync } from "@/lib/settings";
import { CONTENT } from "@/content";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import Heart from "@/pages/Heart";
import Admin from "@/pages/Admin";
import Account from "@/pages/Account";
import Library from "@/pages/Library";
import ContentView from "@/pages/ContentView";
import MyShares from "@/pages/MyShares";
import PrayerRequest from "@/pages/PrayerRequest";
import Legal from "@/pages/Legal";
import Contact from "@/pages/Contact";
import Placeholder from "@/pages/Placeholder";

function App() {
  return (
    <BrowserRouter>
      <ClerkAuthProvider>
        <SettingsProvider>
          <MotionConfig reducedMotion="user">
            <AuthSync />
            <div className="app">
              <Header />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/the-heart-behind-one-share" element={<Heart />} />
                <Route path="/library" element={<Library />} />
                <Route path="/library/:slug" element={<ContentView />} />
                <Route path="/account" element={<Account />} />
                <Route path="/my-shares" element={<MyShares />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/prayer-request" element={<PrayerRequest />} />
                <Route path="/legal" element={<Legal />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/sign-in/*" element={<Navigate to="/account" replace />} />
                <Route path="/sign-up/*" element={<Navigate to="/account" replace />} />
                {Object.keys(CONTENT.placeholders).map((p) => (
                  <Route key={p} path={p} element={<Placeholder />} />
                ))}
              </Routes>
              <Footer />
            </div>
            <Toaster position="top-center" />
          </MotionConfig>
        </SettingsProvider>
      </ClerkAuthProvider>
    </BrowserRouter>
  );
}

export default App;
